import React from 'react';
import { useTranslation } from 'react-i18next';
import { DAY_KEYS_DISPLAY, getCurrentDayKey, getHoursForDay, calculateStatus } from './utils/calculateStatus';

export default function OpeningHours({ openingHours }) {
  const { t } = useTranslation();
  const currentDayKey = getCurrentDayKey();
  const status = openingHours && typeof openingHours === 'object' ? calculateStatus(openingHours) : null;

  if (!openingHours || typeof openingHours !== 'object' || Object.keys(openingHours).length === 0) return null;

  return (
    <section className="ri-section ri-hours" aria-labelledby="ri-hours-heading">
      <h2 id="ri-hours-heading" className="ri-section-title">
        <span className="ri-section-icon" aria-hidden="true">🕐</span>
        {t('restaurant.info.hours')}
      </h2>
      <div className="ri-hours-card">
        {status && status.status !== 'unknown' && (
          <div className={`ri-hours-banner ri-hours-banner--${status.status}`} role="status">
            {status.status === 'open' && (
              <span>✓ {t('restaurant.info.statusOpen', 'Open Now')}{status.closesAt ? ` • ${t('restaurant.info.closesAt', 'Closes at')} ${status.closesAt}` : ''}</span>
            )}
            {status.status === 'closed' && (
              <span>{t('restaurant.info.statusClosed', 'Closed')}{status.nextOpen ? ` • ${t('restaurant.info.opensAt', 'Opens')} ${status.nextOpen}` : ''}</span>
            )}
          </div>
        )}
        <div className="ri-hours-table">
          {DAY_KEYS_DISPLAY.map((key) => {
            const hours = getHoursForDay(openingHours, key);
            const isToday = key === currentDayKey;
            const text = hours ? (hours.closed ? t('restaurant.info.closed') : hours.text) : t('restaurant.info.closed');
            return (
              <div
                key={key}
                className={`ri-hours-row ${isToday ? 'ri-hours-row--today' : ''} ${hours && hours.closed ? 'ri-hours-row--closed' : ''}`}
              >
                <span className="ri-hours-day">
                  {isToday && <span className="ri-hours-dot" aria-hidden="true" />}
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </span>
                <span className="ri-hours-time">{text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
